import * as React from 'react';
import {RemoteBlob} from './remote-blob';
import styles from 'ui/object-fit-image/image.scss';

export const RemoteImage = (props) => {
  const {children, ...rest} = props;

  return (<RemoteBlob {...rest}>
      {({ objectUrl, error }) =>
        error ? <div key="image-error" className={styles.imageError} /> :
          !objectUrl ? <div key="image-loading" className="image-loading"/> :
          children ? children(objectUrl) : <img className="img-fluid" src={objectUrl} />
      }
  </RemoteBlob>);
};
